import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import successIcon from "../../../../assets/icons/successIcon.svg";
import rejected from "../../../../assets/icons/rejected.svg";
import MobileActionHeader from "../../../../components/UI/headingsUI/MobileActionHeader";
import { VisitFilterOptions } from "../../utils/complaintFilter.config";
import FilterSearch from "../../../../components/common/FilterSearch";
import { visitSearch } from "../../../../utils/tableSearchList";
import VisitTableContent from "./VisitTableContent";
import ImageSlider from "../../../../components/UI/viewDialogs/ImageSlider";
import VisitCheckConfirm from "../dialogs/VisitCheckConfirm";
import Dialog from "../../../../components/UI/Dialog";
import { formatVisitExcelData } from "../../utils/excelFormatters";
import { VisitDialog } from "../VisitDialog/VisitDialog";

const VisitPendingList = ({
  handleConfirmDialogBox,
  viewDialogDetails,
  setViewDialogDetails,
  confirmDialogBox,
  setConfirmDialogBox,
  isActionSucceed,
  checkResponseData,
  setIsActionSucceed,
  buttonStatus,
  handleCheck,
  checkLoading,
  setBodyData,
}) => {
  const [imageSliderPics, setImageSliderPics] = useState([]);
  const [imageSliderCurrentIndex, setImageSliderCurrentIndex] = useState();
  const copyData = useSelector((state) => state.data.copyData);
  const isCopyData = copyData.length > 0;

  // ...............get  excel data............
  const excelData = formatVisitExcelData(copyData);
  const excelConfig = {
    data: excelData,
    fileName: "Pending_Visits_Report",
    sheetName: "Pending_Visits",
  };

  const openViewDialog = (visitData) => {
    setViewDialogDetails({ open: true, data: visitData });
  };
  const closeViewDialog = () => {
    setViewDialogDetails({ ...viewDialogDetails, open: false });
  };

  const closeConfirmDialogBox = () => {
    setConfirmDialogBox(false);
    openViewDialog(viewDialogDetails.data);
  };

  const openImageSlider = (Pics) => {
    closeViewDialog();
    setImageSliderPics(Pics);
  };

  const closeImageSlider = () => {
    openViewDialog(viewDialogDetails.data);
    setImageSliderPics([]);
  };

  useEffect(() => {
    if (!isActionSucceed) return;

    const timeoutId = setTimeout(() => {
      setIsActionSucceed(false);
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isActionSucceed]);

  return (
    <>
      {/* page title container for mobile */}
      <MobileActionHeader title="Visits Pending" />
      {/* data filter and data search container  */}
      {isCopyData ? (
        <FilterSearch
          categories={VisitFilterOptions}
          searchCategories={visitSearch}
          isActionSucceed={isActionSucceed}
          checkResponseDataId={[checkResponseData.id]}
          excelConfig={excelConfig}
        />
      ) : (
        ""
      )}
      {/* visit pending table list */}
      <VisitTableContent openViewDialog={openViewDialog} />
      {/* show view dialog box for the specific visit details */}
      {viewDialogDetails?.open && (
        <VisitDialog
          closeDialog={closeViewDialog}
          visit={viewDialogDetails.data}
          openImageSlider={openImageSlider}
          setImageSliderCurrentIndex={setImageSliderCurrentIndex}
          accept={() => handleConfirmDialogBox(viewDialogDetails.data.id, true)}
          reject={() =>
            handleConfirmDialogBox(viewDialogDetails.data.id, false)
          }
          setVisitViewDetails={setViewDialogDetails}
        />
      )}
      {/* show confirm dialog box for the visit checked (accept or reject) */}
      {confirmDialogBox && (
        <VisitCheckConfirm
          title={
            buttonStatus
              ? "Are you sure to Approve this Visit ?"
              : "Are you sure to Reject this Visit ?"
          }
          cancelOnclick={closeConfirmDialogBox}
          checkAction={handleCheck}
          setBodyData={setBodyData}
          checkLoading={checkLoading}
        />
      )}
      {/* show success dialog box after visit checked (accept or reject) */}
      {isActionSucceed && (
        <Dialog
          message={
            buttonStatus ? "Visit Successfully Approved!" : "Visit Rejected!"
          }
          messageIcon={buttonStatus ? successIcon : rejected}
          closeDialog={() => setIsActionSucceed(false)}
        />
      )}
      {/* show view dialog images in image slider box */}
      {imageSliderPics.length !== 0 && (
        <ImageSlider
          title="Visit Photos"
          images={imageSliderPics}
          imageSliderCurrentIndex={imageSliderCurrentIndex}
          closeDialogBox={closeImageSlider}
        />
      )}
    </>
  );
};

export default VisitPendingList;
